/* eslint-disable function-paren-newline */
/* eslint-disable*/
import React, { useState, useEffect, useCallback } from 'react';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import YearEndFormsService from 'src/services/year-end-forms.service';
import { WarningsTable } from 'src/components';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import ReactModal from 'react-modal';
import { HorizonDropdown, RegularButton, ICommonDropdownOption } from 'pg-ui-library';
import closeSvg from 'src/assets/close.svg';
import { IYearEndFormList } from 'src/interfaces/year-end-forms-list';
import { YearEndFormCardItem } from './components/card-item';
import { ChartItem } from './components/chart-item';
import {
  Container,
  ContainerBody,
  ContainerBodyLeft,
  ContainerBodyRight,
  Header,
  HeaderRight,
  HeaderTitle,
  SubHeader,
  CloseIcon,
} from './styles';
import { FormUpload } from './components/form-upload';
import { IYearEndFormGraphic } from 'src/interfaces/year-end-forms-graphic-data';

export const YearEndForm: React.FC = () => {
  const { data: dataCompanies } = useTypedSelector(state => state.config);
  const { t } = useTranslation();
  const [year, setYear] = useState<string>('');
  const [graphicData, setGraphicData] = useState<IYearEndFormGraphic[]>();
  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [formsResult, setFormsResult] = useState<IYearEndFormList[]>();
  const [formType, setFormType] = useState('All');
  const [dropdownTypeOptions, setDropdownTypeOptions] = useState<ICommonDropdownOption[]>([
    {
      key: 'All',
      label: 'All',
      value: 'All',
    },
    {
      key: 'w2-form',
      label: 'W2-FORMS',
      value: 'w2-form',
    },

    {
      key: '1095-c',
      label: '1095-C',
      value: '1095-c',
    },
  ]);
  const [dropdownOptions, setDropdownOptions] = useState<ICommonDropdownOption[]>([
    {
      key: 'All',
      label: 'All',
      value: '',
    },
  ]);

  const {
    // isLoading: loadingForms,
    data: forms,
    refetch: refetchForms,
  } = useQuery(
    ['all-forms-list'],
    () =>
      YearEndFormsService.getW2YearFormsListByYear(
        dataCompanies.config?.selectedCompanyId as unknown as string,
        year,
        formType
      ),
    { enabled: false }
  );
  const { data: w2List, refetch } = useQuery(
    ['w2-list'],
    () => YearEndFormsService.getW2YearFormsList(dataCompanies.config?.selectedCompanyId as unknown as string),
    { enabled: false }
  );

  const { data: graphic, refetch: refetchGraphic } = useQuery(['graphic-data'], () =>
    YearEndFormsService.getYearEndFormsDistributionGraphic(
      dataCompanies.config?.selectedCompanyId as unknown as string,
      year,
      formType
    )
  );

  useEffect(() => {
    refetchForms();
  }, [formType]);

  const mountDropdownOptions = useCallback(() => {
    const cpnsOptions: ICommonDropdownOption[] = w2List?.data.map((item: string) => ({
      key: item,
      label: item,
      value: item,
    }));
    if (cpnsOptions.length > 1) {
      cpnsOptions.unshift({
        key: 'All',
        label: 'All',
        value: '',
      });
    }
    if (cpnsOptions.length < 1) {
      cpnsOptions.push({
        key: 'mType01',
        label: 'Your end-year forms is empty',
        value: '',
      });
    }
    setDropdownOptions(cpnsOptions);
  }, [w2List?.data]);

  const mountGraphicData = useCallback(() => {
    console.log(graphic);
    const allGraphicData: IYearEndFormGraphic[] = [];
    const graphicESSData: IYearEndFormGraphic = {
      // name: 'Mailed By ESS',
      name: `Total Forms: ${graphic?.data[0]?.total}`,
      value: graphic?.data[0]?.total,
      color: '#911100',
    };
    const graphicOnlineData: IYearEndFormGraphic = {
      name: `Downloaded from Portal: ${graphic?.data[0]?.downloaded}`,
      value: graphic?.data[0]?.downloaded,
      color: '#0e1cb3',
    };

    const notSignedIn: IYearEndFormGraphic = {
      name: `Not-Signup: ${graphic?.data[0]?.notSignedIn}`,
      value: graphic?.data[0]?.notSignedIn,
      color: '#0eb369',
    };

    const mail: IYearEndFormGraphic = {
      name: `Mail: ${graphic?.data[0]?.mail}`,
      value: graphic?.data[0]?.mail,
      color: '#d3f20b',
    };

    const notDownloaded: IYearEndFormGraphic = {
      name: `Not downloaded: ${graphic?.data[0]?.notDownloaded}`,
      value: graphic?.data[0].notDownloaded,
      color: '#ffaf23',
    };

    allGraphicData.push(graphicESSData);
    allGraphicData.push(graphicOnlineData);
    allGraphicData.push(notDownloaded);
    allGraphicData.push(notSignedIn);
    allGraphicData.push(mail);

    setGraphicData(allGraphicData);
  }, [graphic?.data]);

  useEffect(() => {
    if (dataCompanies.config?.selectedCompanyId) {
      refetchGraphic();
    }
  }, [dataCompanies.config?.selectedCompanyId]);

  useEffect(() => {
    if (dataCompanies.config?.selectedCompanyId) {
      refetch();
      refetchForms();
      refetchGraphic();
    }
  }, [dataCompanies.config?.selectedCompanyId, year, formType]);

  useEffect(() => {
    if (forms?.data) {
      setFormsResult(forms?.data);
    }
  }, [forms?.data]);

  useEffect(() => {
    if (graphic?.data) {
      mountGraphicData();
    }
  }, [graphic?.data]);

  useEffect(() => {
    if (w2List?.data) {
      mountDropdownOptions();
    }
  }, [w2List?.data]);

  return (
    <Container>
      <Header>
        <HeaderTitle>
          <h3>{t('yearEndForms.title')}</h3>
        </HeaderTitle>
        <HeaderRight>
          <HorizonDropdown
            setValue={(value: string) => {
              setYear(value);
            }}
            placeholder="Choose a Year"
            label="Year"
            options={dropdownOptions}
            selectStyle={{
              width: '100%',
              maxWidth: '500px',
            }}
          />
          <HorizonDropdown
            setValue={(value: string) => {
              setFormType(value);
            }}
            label="Form Type"
            options={dropdownTypeOptions}
            selectStyle={{
              width: '100%',
              maxWidth: '500px',
            }}
          />
        </HeaderRight>
      </Header>
      <SubHeader>
        <RegularButton
          onClick={() => {
            setIsOpen(!modalIsOpen);
          }}
        >
          {t('global.button.uploadForm')}
        </RegularButton>
      </SubHeader>
      <ContainerBody>
        <ContainerBodyLeft>
          {formsResult?.length !== undefined && formsResult?.length > 0 ? (
            formsResult?.map(list => (
              <YearEndFormCardItem
                key={`${list.formType}-${list.year}`}
                title={list.formsTitle}
                formsLoaded={list.formsLoaded}
                formsIssued={list.formsIssued}
                year={list.year}
                formType={list.formType}
              />
            ))
          ) : (
            <WarningsTable />
          )}
        </ContainerBodyLeft>
        <ContainerBodyRight>
          {graphicData ? <ChartItem chartData={graphicData} title={t('yearEndForms.chart.title')} /> : ''}
        </ContainerBodyRight>
      </ContainerBody>
      <ReactModal
        isOpen={modalIsOpen}
        ariaHideApp={false}
        style={{
          overlay: {
            margin: 'auto',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
          },
          content: {
            borderRadius: '10px',
            margin: 'auto',
            width: 'max-content',
            maxWidth: '600px',
            height: 'max-content',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          },
        }}
      >
        <CloseIcon src={closeSvg} onClick={() => setIsOpen(false)} />
        <FormUpload onSubmit={() => setIsOpen(false)} />
      </ReactModal>
    </Container>
  );
};
